<template>
    <trax-ui-horizontal-tabs :tabs="tabs">
        <template slot="tab-1">
            <enac-atpl-dashboard-learner-card-profile></enac-atpl-dashboard-learner-card-profile>
        </template>
        <template slot="tab-2">
            <enac-procedure-atp-daf-group-widget></enac-procedure-atp-daf-group-widget>
        </template>
    </trax-ui-horizontal-tabs>
</template>

<script>
    export default {
    
        data: function() {
            return {
                lang: lang,
                tabs: [
                    {value: 'profile', name: lang.polaris.dashboard.profile, icon: 'person'},
                    {value: 'atp-daf', name: lang.polaris.procedure.atp_daf, icon: 'call_missed_outgoing'},
                ]
            }
        }

    }
</script>
